import gql from 'graphql-tag';

export default gql`
  query footerMenu {
    application(name: DESKTOPBOOKINGPATH) {
      bottomMenu {
        id
        title
        ... on ExpandableMenuItem {
          items {
            id
            title
            link {
              title
              target
              ... on AbsoluteLink {
                url
              }
              ... on RelativeLink {
                path
              }
            }
          }
        }
      }
      mediaMenu {
        id
        title
        link {
          title
          target
          ... on AbsoluteLink {
            url
          }
          ... on RelativeLink {
            path
          }
        }
      }
      # this does not working with the rebranding branch of g4-graphql-schema
      ... on DesktopBookingPath {
        translations(language: enUS) {
          common {
            copyright
          }
        }
        storeButtonsMenu {
          id
          title
          link {
            title
            target
            ... on AbsoluteLink {
              url
            }
            ... on RelativeLink {
              path
            }
          }
          image
        }
      }
    }
  }
`;
